import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';

export function RecordFormLayout({
  title,
  type,
  saving,
  disabled,
  dirty,
  error,
  onBack,
  onSave,
  onSaveAndClose,
  children,
}: {
  title: string;
  type: string;
  saving: boolean;
  disabled: boolean;
  dirty: boolean;
  error: boolean;
  onBack: () => void;
  onSave: () => void;
  onSaveAndClose?: () => void;
  children: React.ReactNode;
}) {
  return (
    <Box sx={{ p: 1 }}>
      <Paper elevation={0} sx={paperSx}>
        <Stack direction="row" sx={{ minHeight: 44, px: 1 }}>
          <Button startIcon={<ArrowBackIcon />} sx={commandSx} onClick={onBack}>
            Back
          </Button>
          <Button
            startIcon={<SaveOutlinedIcon />}
            sx={commandSx}
            disabled={disabled || !dirty || saving}
            onClick={onSave}
          >
            {saving ? 'Saving…' : 'Save'}
          </Button>
          {onSaveAndClose && (
            <Button
              startIcon={<SaveAsOutlinedIcon />}
              sx={commandSx}
              disabled={disabled || !dirty || saving}
              onClick={onSaveAndClose}
            >
              Save &amp; Close
            </Button>
          )}
        </Stack>
      </Paper>
      <Paper elevation={0} sx={{ ...paperSx, mt: 1, p: 2.5 }}>
        <Typography variant="h1">{title}</Typography>
        <Typography color="text.secondary">{type}</Typography>
      </Paper>
      {error && (
        <Alert severity="error" sx={{ mt: 1.5 }}>
          This record could not be saved.
        </Alert>
      )}
      <Paper elevation={0} sx={{ ...paperSx, mt: 1.5, p: { xs: 1.5, sm: 2 }, maxWidth: 760 }}>
        <Typography fontWeight={600} sx={{ mb: 2 }}>{type.toUpperCase()} INFORMATION</Typography>
        {children}
      </Paper>
    </Box>
  );
}
const paperSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  boxShadow: '0 2px 6px rgba(0,0,0,.12)',
};
const commandSx = { color: 'text.primary', '& .MuiButton-startIcon': { color: 'primary.main' } };

